/** Go to matching `()`, `[]`, `{}` (IDM_SEARCH_GOTOMATCHINGBRACE subset). */

const PAIR: Record<string, string> = {
  "(": ")",
  ")": "(",
  "[": "]",
  "]": "[",
  "{": "}",
  "}": "{",
};

/** Offset of the matching bracket, or `null` if none / not on a bracket. */
export function matchingBraceOffset(text: string, caret: number): number | null {
  if (!text.length) return null;
  let i = Math.min(Math.max(0, caret), text.length - 1);
  let ch = text[i]!;
  if (!PAIR[ch]) {
    if (i > 0 && PAIR[text[i - 1]!]) {
      i--;
      ch = text[i]!;
    } else return null;
  }
  const partner = PAIR[ch]!;
  const isOpen = "()[]{}".indexOf(ch) % 2 === 0;
  if (isOpen) {
    let depth = 1;
    for (let j = i + 1; j < text.length; j++) {
      const c = text[j]!;
      if (c === ch) depth++;
      else if (c === partner) {
        depth--;
        if (depth === 0) return j;
      }
    }
    return null;
  }
  let depth = 1;
  for (let j = i - 1; j >= 0; j--) {
    const c = text[j]!;
    if (c === ch) depth++;
    else if (c === partner) {
      depth--;
      if (depth === 0) return j;
    }
  }
  return null;
}
